import * as React from "react";
import Box from "@mui/material/Box";

import CopyAll from "@mui/icons-material/CopyAll";
import {
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridToolbarProps,
} from "@mui/x-data-grid";
import { IBankAccount } from "src/interface/IBankAccount";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { handleCopy } from "src/utilities";
import { useNotifications } from "@toolpad/core/useNotifications";

interface BankAccountFormProps extends GridToolbarProps {
  rows: IBankAccount[];
  open: boolean;
  handleClose: () => void;
}

export default function BankAccountForm({
  rows,
  handleClose,
  open,
}: BankAccountFormProps) {
  const notifications = useNotifications();
  const columns: GridColDef[] = [
    {
      field: "bankName",
      headerName: "بانک",
      minWidth: 150,
      filterable: true,
      align: "center",
      headerAlign: "center",
      flex: 1,
      editable: false,
      sortable: true,
    },
    // {
    //   field: "accountNumber",
    //   headerName: "شماره حساب",
    //   minWidth: 180,
    //   filterable: true,
    //   align: "center",
    //   headerAlign: "center",
    //   flex: 1,
    //   editable: false,
    //   sortable: true,
    // },
    // {
    //   field: "shabaNumber",
    //   headerName: "شماره شبا",
    //   minWidth: 180,
    //   filterable: true,
    //   align: "center",
    //   headerAlign: "center",
    //   flex: 1,
    //   editable: false,
    //   sortable: true,
    // },
    {
      field: "cardNumber",
      headerName: "شماره کارت",
      minWidth: 180,
      filterable: true,
      align: "center",
      headerAlign: "center",
      flex: 1,
      editable: false,
      sortable: true,
      renderCell(params) {
        return (
          <>
            {params.value}{" "}
            <GridActionsCellItem
              icon={<CopyAll />}
              label="کپی"
              className="textPrimary"
              onClick={() => handleCopy(params.row?.cardNumber, notifications)}
              color="inherit"
            />
            ,
          </>
        );
      },
    },
    {
      field: "cvV2",
      headerName: "CVV2",
      minWidth: 150,
      filterable: true,
      align: "center",
      headerAlign: "center",
      flex: 1,
      editable: false,
      sortable: true,
    },
    {
      field: "expireDate",
      headerName: "تاریخ انقضا",
      minWidth: 150,
      filterable: true,
      align: "center",
      headerAlign: "center",

      flex: 1,
      editable: false,
      sortable: true,
      //type: "date",
    },
    {
      field: "ownerName",
      headerName: "نام صاحب حساب",
      minWidth: 200,
      filterable: true,
      align: "center",
      headerAlign: "center",
      flex: 1,
      editable: false,
      sortable: true,
    },
    {
      field: "nationalCode",
      headerName: "کد ملی",
      minWidth: 150,
      filterable: true,
      align: "center",
      headerAlign: "center",
      flex: 1,
      editable: false,
      sortable: true,
      renderCell(params) {
        return (
          <>
            {params.value && (
              <>
                {params.value}
                <GridActionsCellItem
                  icon={<CopyAll />}
                  label="کپی"
                  className="textPrimary"
                  onClick={() =>
                    handleCopy(params.row?.nationalCode, notifications)
                  }
                  color="inherit"
                />
              </>
            )}
            ,
          </>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      minWidth: 150,
      filterable: true,
      align: "center",
      headerAlign: "center",
      flex: 1,
      editable: false,
      sortable: true,
    },
    {
      field: "desc",
      headerName: "توضیحات",
      minWidth: 250,
      filterable: true,
      align: "center",
      headerAlign: "center",
      flex: 1,
      editable: false,
      sortable: true,
    },
  ];

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
        }}
        maxWidth="xl"
        PaperProps={{
          component: "form",

          sx: {
            width: 1400,
          },
        }}
      >
        <DialogTitle>اطلاعات حساب</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              height: "auto",
              width: "100%",
              "& .actions": {
                color: "text.secondary",
              },
              "& .textPrimary": {
                color: "text.primary",
              },
            }}
          >
            <DataGrid
              rows={rows}
              key={"bankAcc"}
              columns={columns}
              editMode="row"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handleClose();
            }}
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
